<template>
  <d2-container>

    <!-- <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary" size="mini"
      icon="el-icon-circle-plus">上传Json文件</el-button> -->




    <!-- <el-dialog title="上传JSON文件" :visible.sync="addSingleDefendantDialog" :close-on-click-modal="false" width="30%" center> -->
    <!-- <el-upload ref="upload1" class="upload-demo" :on-change="fileChange" :action="getUploadloadUrl()"
        :http-request="HttpUploadFile" multiple :auto-upload="false" :limit="1" :file-list="fileList">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <el-button size="small" type="primary">点击上传</el-button>
        </div>
        <div slot="tip" class="el-upload__tip" style="margin: 50px auto; text-align: center">
          上传json文件
        </div>
      </el-upload> -->

    <div style="width:100%; text-align: center;margin-top: 50px;">
      <p
        style="font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB','Microsoft YaHei','微软雅黑',Arial,sans-serif;">
        文件处理工具</p>
      <el-upload ref="upload1" class="upload-demo" drag :action="getUploadloadUrl()" :http-request="HttpUploadFile"
        multiple :auto-upload="false" :limit="5" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">上传文件</div>
      </el-upload>
      <!-- :v-permission:function="[item.permission]" -->

      <div style="text-align: center;width: 100%;margin-top: 30px;">
        <el-select v-model="value" placeholder="选择输出类型">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
            v-permission:function="[item.permission]">
          </el-option>
        </el-select>
      </div>

      <div style="width: 250px; margin: auto;margin-top: 50px;">
        <el-button type="primary" style="width: 100px" @click="addTxt()">确定</el-button>
        <el-button style="width: 100px; margin-left: 40px" @click="addSingleDefendantDialog = false">取 消</el-button>
      </div>

      <div style="margin-top: 5%;width: 800px;text-align: center;margin:0 auto;" v-show="isProgressShow">
        <p style="margin-top: 50px;">第一步:<span v-if="this.isHandling == 0">正在上传...</span><span
            v-else>上传完成</span>{{ this.uploadMessage }}%</p>
        <p style="margin-top: 50px;">第二步:<span v-if="this.uploadMessage == 100">正在处理...</span>{{ this.currNum + '/' +
          this.totalNum }}</p>
        <p style="margin-top: 50px;" v-if="this.totalNum == this.currNum && this.currNum != 0">处理完成，等待下载...</p>
        <el-progress v-if="parseInt(percentage) && this.uploadMessage == 100" style="margin-top: 50px;color: white;"
          :status="progressStatus == null ? progressStatus : null" :text-inside="true" :stroke-width="26"
          :percentage="this.percentage"></el-progress>
        <p style="margin-top:19px;">处理结果</p>
        <p style="margin-top: 50px;"><span v-html="result"></span></p>
      </div>
    </div>
    <!-- </el-dialog> -->


  </d2-container>
</template>

<script>
import axios from "axios";
import util from "@/libs/util";
import { downLoading, uploadSingleFile } from "@/utils/download.js";
export default {
  name: 'liuzhuanManager',
  data() {
    return {
      totalNum: 100,
      currNum: 0,
      isProgressShow: false,
      progressStatus: "",
      isHandling: 0,
      percentage: 0,
      result: '',
      addSingleDefendantDialog: false,
      fileData: new FormData(),
      fileList: [],
      uploadMessage: '',
      listQuery: {
        page: 1,
        limit: 1,
        name: undefined
      },
      downloadList: [],
      downloadIsShow: false,
      options: [{
        value: '1',
        label: '流转表',
        permission: "uploadFile_one"
      }, {
        value: '2',
        label: '导入案件',
        permission: 'uploadFile_two'

      },
      {
        value: '3',
        label: '导入调解案件',
        permission: 'uploadFile_three'
      },
      {
        value: '4',
        label: '拆分起诉卷宗',
        permission: 'uploadFile_four'
      },
      {
        value: '5',
        label: '拆分执行卷宗',
        permission: 'uploadFile_five'
      },{
        value: '6',
        label: '拆分2025版起诉卷宗',
        permission: 'uploadFile_five'
      }],
      value: '',
      taskId: 0,
    }
  },
  created() {

  },
  computed: {

  },
  methods: {
    handleCreate() {
      this.addSingleDefendantDialog = true;
    },
    getUploadloadUrl() {
      return (
        process.env.VUE_APP_API + "/api/case/liuzhuan/upload"
      );
    },
    HttpUploadFile(file) {
      this.fileData.append("fields", file.file);
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
      // this.fileData.append("fields", file); 
    },


    async addTxt() {
      this.addSingleDefendantDialog = false;
      this.$refs.upload1.submit();
      const token = util.cookies.get('token');
      this.fileData.delete("type");
      this.fileData.append("type", this.value);
      var that = this;
      that.totalNum = 100;
      that.currNum = 0;
      that.uploadMessage == 0;
      var interval = null;
      if (this.value == 3) {
        setInterval(
          function () {
            if (this.percentage == 100 || that.totalNum == 0) {
              clearInterval(interval);
              return;
            }
            interval = that.timer();
          }, 1000);

        axios({
          url: process.env.VUE_APP_API + '/api/case/liuzhuan/upload',
          method: 'post',
          data: this.fileData,
          dataType: 'json',
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: 'Bearer ' + token
          }
        }).then((res) => {
          this.result = res.data.message
          this.fileList = [];
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 10000,
          });
          this.value = "";
        }).catch(res => {
          this.isProgressShow = false;
          this.fileList = [];
          this.$notify({
            title: '错误',
            type: 'error',
            message: '文件有误',
            duration: 3000
          });
          this.value = "";
        })

      } else if (this.value == 4 || this.value == 5 || this.value == 6) {
        this.taskId = Math.floor(100000 + Math.random() * 900000);
        this.fileData.append("taskId", this.taskId)
        //拆分PDF
        setInterval(
          function () {
            if (that.isHandling == 1 && that.currNum == this.totalNum) {
              clearInterval(interval);
              return;
            }
            interval = that.timer();
          }, 2000);
        this.isProgressShow = true;
        axios({
          url: process.env.VUE_APP_API + '/api/ocr/casePdfSplit',
          method: 'post',
          data: this.fileData,
          dataType: 'json',
          timeout: 1000 * 60 * 10,
          responseType: "arraybuffer",
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: 'Bearer ' + token
          },
          onUploadProgress: progressEvent => {
            let complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
            that.uploadMessage = complete
          }

        }).then((res) => {
          // that.totalNum = 100;
          // that.currNum = 0;
          // that.uploadMessage == 0;
          //清空表单数据
          for (var key of that.fileData.keys()) {
            that.fileData.delete(key);
          };
          downLoading(res, '.zip')
          this.fileList = [];
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 10000,
          });

        }).catch(res => {
          that.totalNum = 100;
          that.currNum = 0;
          this.isProgressShow = false;
          that.uploadMessage == 0;
          this.fileList = [];
          //清空表单数据
          for (var key of that.fileData.keys()) {
            that.fileData.delete(key);
          };
          this.$notify({
            title: '错误',
            type: 'error',
            message: '文件有误',
            duration: 3000
          });
          this.value = "";
        })


      } else {
        axios({
          url: process.env.VUE_APP_API + '/api/case/liuzhuan/upload',
          method: 'post',
          data: this.fileData,
          dataType: 'json',
          responseType: "arraybuffer",
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: 'Bearer ' + token
          }
        }).then((res) => {

          const disposition = res.headers["content-disposition"];
          const fileName = decodeURI(disposition);
          let url = window.URL.createObjectURL(
            new Blob([res.data], { type: ".zip" })
          );
          let a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.setAttribute("download", fileName);
          document.body.appendChild(a);
          a.click();
          url = window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.fileList = [];
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 10000,
          });

        })

      }

      this.isProgressShow = true;

    },

    timer: function () {//写成timer()也可
      const token = util.cookies.get('token');
      var reqUrl;
      if (this.value == 3) {
        reqUrl = process.env.VUE_APP_API + '/api/case/liuzhuan/getProgress'
      }
      if (this.value == 4 || this.value == 5 || this.value == 6) {
        reqUrl = process.env.VUE_APP_API + '/api/ocr/pdfProgress/' + this.taskId
      }
      axios({
        url: reqUrl,
        method: 'get',
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: 'Bearer ' + token
        }
      }).then(res => {
        this.totalNum = res.data.data.totalNum;
        this.currNum = res.data.data.currNum;
        this.isHandling = res.data.data.isHandling;
        if (res.data.data.currNum == '0' && res.data.data.totalNum == '0') {
          this.percentage = 100;
          return;
        } else {
          this.percentage = Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100);
          if (Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) <= 30) {
            this.progressStatus = 'exception';
          } else if (Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) > 30 && Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) <= 50) {
            this.progressStatus = 'warning';
          } else if (Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) > 50 && Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) <= 80) {
            this.progressStatus = '';
          } else if (Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) > 80 && Math.floor((res.data.data.currNum / res.data.data.totalNum) * 100) <= 100) {
            this.progressStatus = 'success';
          }
        }

      });
    }
  }
}
</script>
